/* Solvofit: galería de producto.
   Imagen grande que avanza sola, miniaturas debajo y visor a pantalla completa
   con fondo difuminado, zoom (clic, doble toque, pellizco o botón) y flechas. */
(() => {
  if (customElements.get('sf-gallery')) return;

  const ICONS = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>',
    zoomIn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5M11 8v6M8 11h6"/></svg>',
    zoomOut: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5M8 11h6"/></svg>',
  };
  const ZOOM = 2.5;
  const MAX_ZOOM = 4;

  /* ---------- Visor (uno solo por página, vive en <body>) ---------- */
  class SfLightbox {
    constructor() {
      const el = document.createElement('div');
      el.className = 'sf-lightbox';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Imagen del producto');
      el.innerHTML = `
        <div class="sf-lightbox__backdrop"></div>
        <div class="sf-lightbox__veil"></div>
        <div class="sf-lightbox__viewport"><div class="sf-lightbox__frame"></div></div>
        <button type="button" class="sf-lightbox__btn sf-lightbox__zoom" aria-label="Acercar">${ICONS.zoomIn}</button>
        <button type="button" class="sf-lightbox__btn sf-lightbox__close" aria-label="Cerrar">${ICONS.close}</button>
        <button type="button" class="sf-lightbox__btn sf-lightbox__prev" aria-label="Imagen anterior">${ICONS.prev}</button>
        <button type="button" class="sf-lightbox__btn sf-lightbox__next" aria-label="Imagen siguiente">${ICONS.next}</button>`;
      document.body.appendChild(el);

      this.el = el;
      this.backdrop = el.querySelector('.sf-lightbox__backdrop');
      this.viewport = el.querySelector('.sf-lightbox__viewport');
      this.frame = el.querySelector('.sf-lightbox__frame');
      this.zoomBtn = el.querySelector('.sf-lightbox__zoom');
      this.prevBtn = el.querySelector('.sf-lightbox__prev');
      this.nextBtn = el.querySelector('.sf-lightbox__next');

      this.items = [];
      this.index = 0;
      this.z = 1;
      this.x = 0;
      this.y = 0;
      this.pointers = new Map();

      el.querySelector('.sf-lightbox__close').addEventListener('click', () => this.close());
      this.prevBtn.addEventListener('click', () => this.go(this.index - 1, -1));
      this.nextBtn.addEventListener('click', () => this.go(this.index + 1, 1));
      this.zoomBtn.addEventListener('click', () => (this.z > 1 ? this.resetZoom(true) : this.zoomAtCenter(ZOOM)));

      this.viewport.addEventListener('pointerdown', this.onDown.bind(this));
      this.viewport.addEventListener('pointermove', this.onMove.bind(this));
      this.viewport.addEventListener('pointerup', this.onUp.bind(this));
      this.viewport.addEventListener('pointercancel', this.onUp.bind(this));
      this.viewport.addEventListener(
        'wheel',
        (e) => {
          if (!this.img || !e.ctrlKey) return; // pellizco en trackpad
          e.preventDefault();
          this.zoomAt(e.clientX, e.clientY, this.z * (e.deltaY < 0 ? 1.08 : 0.92));
        },
        { passive: false }
      );

      document.addEventListener('keydown', (e) => {
        if (!this.isOpen) return;
        if (e.key === 'Escape') this.close();
        else if (e.key === 'ArrowLeft') this.go(this.index - 1, -1);
        else if (e.key === 'ArrowRight') this.go(this.index + 1, 1);
      });
    }

    open(items, index, owner) {
      this.items = items;
      this.owner = owner;
      this.lastFocus = document.activeElement;
      this.isOpen = true;
      const single = items.length < 2;
      this.prevBtn.hidden = single;
      this.nextBtn.hidden = single;
      document.documentElement.classList.add('sf-lightbox-open');
      this.el.classList.add('is-open');
      this.show(index);
      requestAnimationFrame(() => this.el.classList.add('is-visible'));
      this.el.querySelector('.sf-lightbox__close').focus({ preventScroll: true });
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.frame.innerHTML = '';
      this.img = null;
      this.slideEl = null;
      this.el.classList.remove('is-visible', 'is-open', 'is-zoomed');
      document.documentElement.classList.remove('sf-lightbox-open');
      this.owner?.onLightboxClosed(this.index);
      this.lastFocus?.focus?.({ preventScroll: true });
    }

    go(i, dir = 0) {
      if (!this.items.length) return;
      this.show((i + this.items.length) % this.items.length, dir);
    }

    // Cada foto vive en su propia "diapositiva": la que sale se desliza y se desvanece
    // mientras la nueva entra desde el otro lado.
    show(i, dir = 0) {
      this.index = i;
      const item = this.items[i];
      this.resetZoom(false);
      this.backdrop.style.backgroundImage = `url("${item.full}")`;

      const old = this.slideEl;
      const slide = document.createElement('div');
      slide.className = 'sf-lightbox__slide';
      if (dir) slide.classList.add(dir > 0 ? 'is-enter-next' : 'is-enter-prev');

      this.img = null;
      if (item.html) {
        const wrap = document.createElement('div');
        wrap.className = 'sf-lightbox__media';
        wrap.appendChild(item.html.content.cloneNode(true));
        slide.appendChild(wrap);
        this.zoomBtn.hidden = true;
      } else {
        this.zoomBtn.hidden = false;
        const img = new Image();
        img.className = 'sf-lightbox__img';
        img.alt = item.alt || '';
        img.draggable = false;
        img.decoding = 'async';
        img.addEventListener('load', () => img.classList.add('is-loaded'));
        img.src = item.full;
        if (img.complete) img.classList.add('is-loaded');
        slide.appendChild(img);
        this.img = img;
        this.apply(false);
      }

      this.frame.appendChild(slide);
      this.slideEl = slide;

      if (old) {
        if (dir) {
          old.classList.remove('is-dragging');
          old.style.opacity = '';
          old.style.transform = '';
          old.classList.add(dir > 0 ? 'is-leave-next' : 'is-leave-prev');
          old.setAttribute('aria-hidden', 'true');
          setTimeout(() => old.remove(), 650);
        } else {
          old.remove();
        }
      }
      if (dir) {
        requestAnimationFrame(() =>
          requestAnimationFrame(() => slide.classList.remove('is-enter-next', 'is-enter-prev'))
        );
      }

      // Precarga la siguiente y la anterior
      [i + 1, i - 1].forEach((k) => {
        const it = this.items[(k + this.items.length) % this.items.length];
        if (it && !it.html) new Image().src = it.full;
      });
    }

    /* ---- zoom ---- */
    apply(animate) {
      if (!this.img) return;
      this.img.classList.toggle('is-animating', !!animate);
      this.img.style.setProperty('--sf-z', this.z);
      this.img.style.setProperty('--sf-x', `${this.x}px`);
      this.img.style.setProperty('--sf-y', `${this.y}px`);
      this.el.classList.toggle('is-zoomed', this.z > 1.01);
      this.zoomBtn.innerHTML = this.z > 1.01 ? ICONS.zoomOut : ICONS.zoomIn;
      this.zoomBtn.setAttribute('aria-label', this.z > 1.01 ? 'Alejar' : 'Acercar');
    }

    baseRect() {
      // Posición del dibujo sin zoom (offset* ignora las transformaciones)
      const f = (this.slideEl || this.frame).getBoundingClientRect();
      return {
        left: f.left + this.img.offsetLeft,
        top: f.top + this.img.offsetTop,
        width: this.img.offsetWidth,
        height: this.img.offsetHeight,
      };
    }

    clamp() {
      const r = this.baseRect();
      this.x = Math.min(0, Math.max(r.width * (1 - this.z), this.x));
      this.y = Math.min(0, Math.max(r.height * (1 - this.z), this.y));
    }

    zoomAt(clientX, clientY, z, animate) {
      if (!this.img) return;
      z = Math.max(1, Math.min(MAX_ZOOM, z));
      const r = this.baseRect();
      // punto bajo el dedo/cursor, en coordenadas de la imagen sin zoom
      const u = (clientX - r.left - this.x) / this.z;
      const v = (clientY - r.top - this.y) / this.z;
      this.x = clientX - r.left - u * z;
      this.y = clientY - r.top - v * z;
      this.z = z;
      this.clamp();
      this.apply(animate);
    }

    zoomAtCenter(z) {
      if (!this.img) return;
      const r = this.baseRect();
      this.zoomAt(r.left + r.width / 2, r.top + r.height / 2, z, true);
    }

    resetZoom(animate) {
      this.z = 1;
      this.x = 0;
      this.y = 0;
      this.apply(animate);
    }

    /* ---- gestos ---- */
    onDown(e) {
      if (e.target.closest('.sf-lightbox__btn')) return;
      this.viewport.setPointerCapture?.(e.pointerId);
      this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (this.pointers.size === 1) {
        this.start = { x: e.clientX, y: e.clientY, px: this.x, py: this.y, t: Date.now() };
        this.downOnImage = !!this.img && e.target === this.img;
        this.moved = false;
      } else if (this.pointers.size === 2) {
        const [a, b] = [...this.pointers.values()];
        this.pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), z: this.z };
        this.moved = true;
      }
    }

    onMove(e) {
      if (!this.pointers.has(e.pointerId)) return;
      this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (this.pointers.size === 2 && this.pinch && this.img) {
        const [a, b] = [...this.pointers.values()];
        const d = Math.hypot(a.x - b.x, a.y - b.y);
        this.zoomAt((a.x + b.x) / 2, (a.y + b.y) / 2, this.pinch.z * (d / this.pinch.d));
        return;
      }
      if (!this.start) return;
      const dx = e.clientX - this.start.x;
      const dy = e.clientY - this.start.y;
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) this.moved = true;

      // Sin zoom, la foto sigue al dedo/mouse al deslizar hacia los lados
      if (this.z <= 1.01 && this.slideEl && this.pointers.size === 1 && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) {
        const w = this.frame.clientWidth || 1;
        this.slideEl.classList.add('is-dragging');
        this.slideEl.style.transform = `translateX(${dx}px) scale(${1 - Math.min(Math.abs(dx) / w, 1) * 0.04})`;
        this.slideEl.style.opacity = String(1 - Math.min(Math.abs(dx) / w, 1) * 0.5);
        return;
      }

      if (this.z > 1.01 && this.img) {
        this.el.classList.add('is-dragging');
        this.x = this.start.px + dx;
        this.y = this.start.py + dy;
        this.clamp();
        this.apply(false);
      }
    }

    onUp(e) {
      if (!this.pointers.has(e.pointerId)) return;
      this.pointers.delete(e.pointerId);
      this.el.classList.remove('is-dragging');
      if (this.pointers.size === 1) {
        // Termina el pellizco: sigue arrastrando con el dedo que queda
        const [p] = [...this.pointers.values()];
        this.start = { x: p.x, y: p.y, px: this.x, py: this.y, t: Date.now() };
        this.pinch = null;
        return;
      }
      if (this.pointers.size > 0 || !this.start) return;
      this.pinch = null;

      const dx = e.clientX - this.start.x;
      const dy = e.clientY - this.start.y;
      const start = this.start;
      this.start = null;
      if (e.type === 'pointercancel') {
        this.snapBack();
        return;
      }

      // Deslizar para cambiar de imagen (solo sin zoom)
      if (this.z <= 1.01 && this.moved) {
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && this.items.length > 1) {
          const dir = dx < 0 ? 1 : -1;
          this.go(this.index + dir, dir);
        } else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) {
          this.close();
        } else {
          this.snapBack();
        }
        return;
      }
      if (this.moved) return;

      // Toque/clic sin moverse
      const onImage = this.downOnImage;
      if (e.pointerType === 'mouse') {
        if (onImage) this.z > 1.01 ? this.resetZoom(true) : this.zoomAt(e.clientX, e.clientY, ZOOM, true);
        else if (this.z <= 1.01) this.close();
        return;
      }
      // Táctil: doble toque = zoom, toque fuera de la imagen = cerrar
      const now = Date.now();
      if (this.lastTap && now - this.lastTap.t < 320 && Math.hypot(e.clientX - this.lastTap.x, e.clientY - this.lastTap.y) < 30) {
        this.lastTap = null;
        clearTimeout(this.tapTimer);
        if (!this.img) return;
        this.z > 1.01 ? this.resetZoom(true) : this.zoomAt(e.clientX, e.clientY, ZOOM, true);
        return;
      }
      this.lastTap = { t: now, x: e.clientX, y: e.clientY };
      if (!onImage && this.z <= 1.01 && now - start.t < 400) {
        this.tapTimer = setTimeout(() => this.isOpen && this.lastTap && this.close(), 330);
      }
    }
  }

  SfLightbox.prototype.snapBack = function () {
    // La foto vuelve suavemente a su lugar si el deslizamiento fue corto
    const s = this.slideEl;
    if (!s) return;
    s.classList.remove('is-dragging');
    s.style.transform = '';
    s.style.opacity = '';
  };

  let lightbox;
  const getLightbox = () => (lightbox ||= new SfLightbox());

  /* ---------- Galería en la página ---------- */
  customElements.define(
    'sf-gallery',
    class SfGallery extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('[data-stage]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-thumb]')];
        if (!this.slides.length) return;

        this.interval = parseInt(this.dataset.interval, 10) || 5000;
        this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));

        this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i, true)));

        // Efecto "Hue": resplandor con los colores de la foto activa detrás de la imagen grande
        this.glow = document.createElement('div');
        this.glow.className = 'sf-gallery__glow';
        this.glow.setAttribute('aria-hidden', 'true');
        this.glowLayers = [0, 1].map(() => {
          const layer = document.createElement('div');
          layer.className = 'sf-gallery__glow-layer';
          this.glow.appendChild(layer);
          return layer;
        });
        this.glowIndex = 0;
        this.stage.before(this.glow);
        this.preloadGlows();
        this.updateGlow();

        // Clic en la imagen grande: abre el visor. Deslizar: cambia de imagen.
        this.stage.addEventListener('pointerdown', (e) => {
          this.drag = { x: e.clientX, y: e.clientY };
          this.dragged = false;
        });
        this.stage.addEventListener('pointermove', (e) => {
          if (!this.drag) return;
          if (Math.abs(e.clientX - this.drag.x) > 8) this.dragged = true;
        });
        const endDrag = (e) => {
          if (!this.drag) return;
          const dx = e.clientX - this.drag.x;
          const dy = e.clientY - this.drag.y;
          this.drag = null;
          if (this.dragged && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.go(this.index + (dx < 0 ? 1 : -1), true);
          }
        };
        this.stage.addEventListener('pointerup', endDrag);
        this.stage.addEventListener('pointercancel', () => (this.drag = null));
        this.stage.addEventListener('click', (e) => {
          if (this.dragged) {
            this.dragged = false;
            e.preventDefault();
            return;
          }
          this.openLightbox();
        });

        // Al elegir otra variante, mostrar su imagen
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data?.sectionId !== this.dataset.section) return;
            const id = data?.variant?.featured_media?.id;
            if (!id) return;
            const i = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
            if (i >= 0) this.go(i, true);
          });
        }

        document.addEventListener('visibilitychange', (this.onVisibility = () => this.restart()));
        this.restart();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.unsubscribe?.();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      restart() {
        clearTimeout(this.timer);
        if (this.slides.length < 2 || this.paused || document.hidden) return;
        this.timer = setTimeout(() => this.go(this.index + 1, false), this.interval);
      }

      go(i, userAction) {
        const n = this.slides.length;
        const next = ((i % n) + n) % n;
        if (next !== this.index) {
          const forward = userAction ? next > this.index : true;
          const prev = this.slides[this.index];
          const cur = this.slides[next];
          this.slides.forEach((s) => s.classList.remove('is-leaving'));
          cur.style.setProperty('--sf-from', forward ? '4%' : '-4%');
          prev.style.setProperty('--sf-to', forward ? '-4%' : '4%');
          prev.classList.remove('is-active');
          prev.classList.add('is-leaving');
          prev.setAttribute('aria-hidden', 'true');
          cur.classList.add('is-active');
          cur.removeAttribute('aria-hidden');
          setTimeout(() => prev.classList.remove('is-leaving'), 700);
          this.index = next;
          this.syncThumbs();
          this.updateGlow();
        }
        this.restart();
      }

      glowSrc(i) {
        const img = this.slides[i]?.querySelector('img');
        if (!img) return '';
        // Versión chica de la foto: basta para el resplandor y carga rápido
        return (img.getAttribute('src') || img.currentSrc || '').replace(/([?&])width=\d+/, '$1width=300');
      }

      preloadGlows() {
        // Precarga todos los colores para que el cambio sea inmediato y suave
        this.glowReady = this.slides.map((_, i) => {
          const src = this.glowSrc(i);
          if (!src) return Promise.resolve();
          const im = new Image();
          im.src = src;
          return (im.decode ? im.decode() : Promise.resolve()).catch(() => {});
        });
      }

      updateGlow() {
        if (!this.glowLayers) return;
        const index = this.index;
        const src = this.glowSrc(index);
        if (!src) return;
        const token = (this.glowToken = (this.glowToken || 0) + 1);
        const ready = this.glowReady?.[index] || Promise.resolve();
        ready.then(() => {
          if (token !== this.glowToken) return;
          const prev = this.glowLayers[this.glowIndex];
          this.glowIndex = 1 - this.glowIndex;
          const cur = this.glowLayers[this.glowIndex];
          clearTimeout(this.glowTimer);
          // La capa nueva aparece encima de la anterior y luego la anterior se apaga: sin saltos
          cur.classList.remove('is-on');
          cur.style.backgroundImage = `url("${src}")`;
          prev.classList.remove('is-top');
          cur.classList.add('is-top');
          requestAnimationFrame(() => requestAnimationFrame(() => cur.classList.add('is-on')));
          this.glowTimer = setTimeout(() => prev.classList.remove('is-on'), 1800);
        });
      }

      syncThumbs() {
        this.thumbs.forEach((t, i) => {
          const active = i === this.index;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        const t = this.thumbs[this.index];
        const row = t?.parentElement;
        if (t && row && row.scrollWidth > row.clientWidth) {
          row.scrollTo({ left: t.offsetLeft - row.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      }

      openLightbox() {
        const items = this.slides.map((s) => ({
          full: s.dataset.full,
          alt: s.dataset.alt,
          html: s.dataset.type !== 'image' ? s.querySelector('template[data-media-html]') : null,
        }));
        this.paused = true;
        clearTimeout(this.timer);
        getLightbox().open(items, this.index, this);
      }

      onLightboxClosed(index) {
        this.paused = false;
        this.go(index, true);
      }
    }
  );
})();
